<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.branchName')
            }}</label>
            <ts-branch-filter @filter="setBranchList" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.academicYear')
            }}</label>
            <a-select
              style="width:100%"
              v-model="acYearId"
              :options="acYearOptions"
              @change="getTerm"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.mainProgram')
            }}</label>
            <a-select
              style="width:100%"
              v-model="acpId"
              :options="mainProgram"
              @change="() => (acTermId = null)"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.academicTerm')
            }}</label>
            <a-select
              style="width:100%"
              v-model="acTermId"
              :options="listOfTerm"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.scoringCycle')
            }}</label>
            <a-select
              style="width:100%"
              v-model="cycle"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            >
              <a-select-option
                v-for="(s, index) in scoringCycle"
                :key="index"
                :value="s.scoring_cycle_id"
              >
                {{ s.scoring_cycle_name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'drawerFilter',
  data() {
    return {
      loading: false,
      acYearOptions: [],
      mainProgram: [],
      termLists: []
    }
  },
  created() {
    this.fetchAcYear()
  },
  computed: {
    cycle: {
      get() {
        return this.$store.state.studentScoringEntry.scoring_cycle_id
      },
      set(newValue) {
        this.$store.commit('studentScoringEntry/SET_SCORING_CYCLE_ID', newValue)
      }
    },
    acYearId: {
      get() {
        return this.$store.state.studentScoringEntry.ac_year_id
      },
      set(newValue) {
        this.$store.commit('studentScoringEntry/SET_AC_YEAR_ID', newValue)
      }
    },
    acpId: {
      get() {
        return this.$store.state.studentScoringEntry.acp_id
      },
      set(newValue) {
        this.$store.commit('studentScoringEntry/SET_MAIN_PROGRAM', newValue)
      }
    },
    acTermId: {
      get() {
        return this.$store.state.studentScoringEntry.ac_term_id
      },
      set(newValue) {
        this.$store.commit('studentScoringEntry/SET_AC_TERM_ID', newValue)
      }
    },
    listOfTerm() {
      return this.termLists
        .filter(t => t.acp_id == this.acpId)
        .map(el => ({
          value: el.ac_term_id,
          label: el.term_name
        }))
    },
    scoringCycle() {
      return this.$store.state.studentScoringEntry.scoring_cycles
    }
  },
  methods: {
    async fetchAcYear() {
      this.loading = true
      await this.$store
        .dispatch('studentScoringEntry/getScoringCycle')
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('studentScoringEntry/getAcYear')
        .then(response => {
          this.acYearOptions = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('studentScoringEntry/getMainProgram')
        .then(response => {
          this.mainProgram = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    setBranchList(branch) {
      this.$store.commit('studentScoringEntry/SET_BRANCH_LIST', branch)
    },
    getTerm() {
      this.acpId = null
      this.acTermId = null
      this.loading = true
      this.$store
        .dispatch('studentScoringEntry/getAcTerm')
        .then(response => {
          this.termLists = response.data.map(el => ({
            ac_term_id: el.ac_term_id,
            term_name: el.term_name,
            acp_id: el.sub_program.acp_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
